export default "__VITE_ASSET__DoG_3Q9P__"